import css from "@styles/layout/header/icon.module.scss";

export default function Icon() {
	return <img className={css.icon} src="/assets/images/misc/icon.png" alt="Icon" />;
}
